<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Kreditoriai</h3>

    <hipoteka-asmenys :asmuo-role="asmuoRole" :readonly="isReadonlyForm" />

    <hipoteka-istorija duomenys="kreditoriai" />

    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button v-if="!isReadonlyForm" primary @click.native="checkErrors()"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import checkErrors from '../../mixins/checkErrors'
import HipotekaAsmenys from './HipotekaAsmenys'
import HipotekaIstorija from './istorija/HipotekaIstorija'

export default {
  name: 'HipotekaKreditoriai',
  components: {
    HipotekaAsmenys,
    HipotekaIstorija,
  },
  mixins: [checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(['hipotekaReadonly']),
    asmuoRole() {
      return HipotekaMap['asmenysRoles'].kreditorius
    },
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
